/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SystemRoleBit } from '@gh/builder-shared-data';
import { createDialogRoute, FormState, FormStateBuilder } from '@gh/common-shared';
import { AutocompleteLoadMoreEvent, DialogInput, FormMode, getControlValue } from '@gh/core-ui';
import { isNil } from 'lodash';
import { JobDetailsTabBusinessService, UserListItem } from '../../../resources/job-details-tab';

export interface SelectSupervisorDialogConfig {
  systemRole: SystemRoleBit;
}

@Component({
  selector: 'gh-select-supervisor-dialog',
  template: require('./select-supervisor-dialog.component.html'),
  styles: [require('./select-supervisor-dialog.component.scss')],
})
export class SelectSupervisorDialogComponent implements OnInit, DialogInput<SelectSupervisorDialogConfig> {
  input: SelectSupervisorDialogConfig;
  form: FormState<{ supervisor: UserListItem }>;

  constructor(public dialogRef: MatDialogRef<any>,
              private formStateBuilder: FormStateBuilder,
              private businessService: JobDetailsTabBusinessService) {

  }

  get supervisorSelected(): boolean {
    return !isNil(getControlValue(this.form.group, 'supervisor'));
  }

  ngOnInit(): void {
    this.form = this.formStateBuilder.buildPlain({
      value: void 0,
      mode: FormMode.EditMode,
      enabled: true,
      children: {
        supervisor: { required: true },
      },
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onApply(): void {
    if (this.form.group.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.dialogRef.close(this.form.submitValue.supervisor);
  }

  loadAdmins($event: AutocompleteLoadMoreEvent): void {
    $event.load(this.businessService.findUsers($event.query, this.input.systemRole));
  }
}

export const selectSupervisorDialogRoute = createDialogRoute({
  component: SelectSupervisorDialogComponent,
});
